<template>
  <mds-section
    class="frequency-modal__header"
    bold
    border="none"
    :size="4"
    :title="modalTitle"
  >
    <template #mds-section-title-description>
      <mds-button
        variation="icon-only"
        icon="question-circle"
        type="button"
        target="_blank"
        :href="supportUrl"
      />
    </template>
    <p class="frequency-modal__description">
      {{ translate(modalDescription) }}
    </p>
  </mds-section>
</template>

<script>
import { mapState } from 'vuex'
import MdsSection from '@mds/section'
import { MdsButton } from '@mds/button'
import MwcBaseHelpersMixin from '@morningstar/mcl-utilities/src/vue/mixins/mwc-base-mixin'
import defaultConfig from '@/components/frequencyModal/config/i18n'

export default {
  name: 'FrequencyModalHeader',
  components: {
    MdsSection,
    MdsButton,
  },
  mixins: [MwcBaseHelpersMixin],
  data() {
    return {
      defaultConfig,
    }
  },
  computed: {
    ...mapState({
      editedSchedule: (state) => state.cache.cache.editedSchedule,
      cache: (state) => state.cache.cache,
    }),
    modalTitle() {
      return this.editedSchedule
        ? this.translate('frequency.modal.edit.title')
        : this.translate('frequency.modal.title')
    },
    supportUrl() {
      return process.env.SUPPORT_URL
    },
    modalDescription() {
      return this.cache.requestFromLens
        ? 'frequency.modal.description.lens'
        : 'frequency.modal.description'
    },
  },
}
</script>

<style lang="scss" scoped>
@import '@mds/constants';
@import '@mds/typography';
.frequency-modal {
  &__header {
    &::v-deep > [class^='mds-section__header-container'] {
      margin-bottom: $mds-space-1-x;

      h2 {
        display: flex;
        align-items: center;
        justify-content: space-between;
        width: 100%;

        &::after,
        &::before {
          display: none;
        }
      }
    }
  }
  &__description {
    @include mds-body-text-s();
    color: $mds-text-color-secondary;
    margin-top: $mds-space-1-x;
    margin-bottom: 20px;
  }
}
</style>
